import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { getProviderInfo, updateProviderInfo } from "../slice/providerPanelSlice";
import { useLoadScript, Autocomplete } from '@react-google-maps/api';

const ProviderPanelInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { providersInfo: provider, loading } = useSelector((state) => state.providerInfo);

    const providerToken = localStorage.getItem("provider_access_token");
    const token = providerToken;
    const fileInputRef = useRef(null);

    // console.log("provider", provider);
    const [displayImage, setDisplayImage] = useState(null);
    const [originalProfileImage, setOriginalProfileImage] = useState(null);
  const [formData, setFormData] = useState({
    company_name: "",
    contact_name: "",
    contact_name1: "",
    contact_number: "",
    email: "",
    address: "",
    description: "",
    city: "",
    state: "",
    zipcode: "",
    lat: "",
    long: "",
    country: "",
  });


    const libraries = ['places'];
  
    const { isLoaded } = useLoadScript({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries
    });
  
      const autocompleteRef = useRef(null);


      const handlePlaceChanged = () => {
  const place = autocompleteRef.current?.getPlace();
  if (!place) return;

  const addressComponents = place.address_components || [];
  const getComponent = (types) =>
    addressComponents.find((component) =>
      types.every((type) => component.types.includes(type))
    )?.long_name || "";

  const city = getComponent(["locality"]) || getComponent(["sublocality"]);
  const state = getComponent(["administrative_area_level_1"]);
  const zipcode = getComponent(["postal_code"]);
  const country = getComponent(["country"]);
  const lat = place.geometry?.location?.lat() || "";
  const long = place.geometry?.location?.lng() || "";

  setFormData((prev) => ({
    ...prev,
    address: place.formatted_address || "",
    city,
    state,
    zipcode,
    country,
    lat,
    long
  }));
};

   const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'profile_image') {
      // If the user selects a new file, update formData and leave the displayImage unchanged
      setFormData((prev) => ({
        ...prev,
        profile_image: files.length > 0 ? files[0] : prev.profile_image, // Store the File object
      }));
    } else {
      // Handle other form fields
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    dispatch(getProviderInfo(token));
  }, [dispatch]);

  useEffect(() => {
    if (provider) {
      setFormData({
        company_name: provider.company_name || "",
        contact_name: provider.contact_name || "",
        contact_name1: provider.contact_name1 || "",
        contact_number: provider.contact_number || "",
        email: provider.email || "",
        address: provider.address || "",
        description: provider.description || "",
        city: provider.city || "",
        state: provider.state || "",
        zipcode: provider.zipcode || "",
        lat: provider.lat || "",
        long: provider.long || "",
        country: provider.country || "",
        profile_image: provider.profile_image || "",
      });

      setOriginalProfileImage(provider.profile_image || null);

      setDisplayImage(provider.profile_image || null);
    }
  }, [provider]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem("provider_access_token");
  const updatedData = { ...formData };
if (
    !updatedData.profile_image || 
    (typeof updatedData.profile_image === "string" && updatedData.profile_image === originalProfileImage)
  ) {
    delete updatedData.profile_image;
  }
// console.log("formData", formData);
// console.log("updatedData", updatedData);
// return;
  const result = await dispatch(updateProviderInfo({ formData: updatedData, token }));

   if (result.meta.requestStatus === "fulfilled") {
  
        toast.success("Update successful!", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
  
        navigate("/provider/panel");
        dispatch(getProviderInfo(token));
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      } else {
        toast.error("Update failed", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
        });
    }
};

  return (
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">My Info</h4>
          <div className="form-section mt-3">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Company Name</label>
                  <input
                    type="text"
                    name="company_name"
                    className="form-control"
                    value={formData.company_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-3">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Contact First Name</label>
                  <input
                    type="text"
                    name="contact_name"
                    className="form-control"
                    value={formData.contact_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-3">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Contact Last Name</label>
                  <input
                    type="text"
                    name="contact_name1"
                    className="form-control"
                    value={formData.contact_name1}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Contact Number</label>
                  <input
                    type="text"
                    name="contact_number"
                    className="form-control"
                    value={formData.contact_number}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>                
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Address</label>
                  {isLoaded && (
                    <Autocomplete
                      onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                      onPlaceChanged={handlePlaceChanged}
                    >
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  </Autocomplete>
                                            )}
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Profile Image</label>
                  
                  <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                    {/* Upload Field */}
                    <div className="uploadfield flex-fill">
                      <div className="custom-file-upload position-relative">
                        <button
                          type="button"
                          className="upload-btn btn btn-custom-primary position-absolute"
                          onClick={() => document.getElementById('profileImage')?.click()}
                        >
                          Upload Files
                        </button>
                        <input
                          type="file"
                          name="profile_image"
                          id="profileImage"
                          accept=".jpg,.jpeg,.png"
                          onChange={handleChange}
                          ref={fileInputRef}
                        />
                      </div>
                      <div className="file-name form-control" id="fileName">
                        {formData.profile_image?.name || "No file chosen"}
                      </div>
                      <div className="text-muted leaveblank d-block pt-1">
                        <small>
                          Supported: JPG, JPEG, PNG. Max size: 1 MB.
                        </small>
                      </div>
                    </div>

                    {/* Display Image */}
                    {displayImage && typeof displayImage === 'string' && (
                      <div className="text-md-end text-start">
                        <div className="mb-2">
                          <img
                            src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${displayImage}`}
                            alt="Profile"
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-sm-4">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">City</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    placeholder="Enter City"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-4">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">State</label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    placeholder="Enter State"
                    value={formData.state}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-4">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Zip Code</label>
                  <input
                    type="text"
                    name="zipcode"
                    className="form-control"
                    placeholder="Enter Zip Code"
                    value={formData.zipcode}
                    onChange={handleChange}
                  />
                </div>
                <input
                  type="hidden"
                  name="lat"
                  className="form-control"
                  value={formData.lat}
                />
                <input
                  type="hidden"
                  name="long"
                  className="form-control"
                  value={formData.long}
                />
                <div className="col-12">
                  <label className="form-label text-primary mb-1 font-weight-semibold font-size-16 required">Massage</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="description"
                    placeholder="Enter Massage"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 text-center mt-4 pt-md-2">
                  <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"><span className="d-block py-1">Update</span></button>
                  <button className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"><span className="d-block py-1">Cancel</span></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProviderPanelInfo;
